import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material';
import { useBreadcrumbsContext } from '../../../../app/context';
import { HeaderButtons, OperationsMainContainer, PendingCount } from './styles';
import { CustomTabs } from 'app/components/CustomTabs';
import { routingPath } from 'app/routes';
import { AddIcon, WarningIcon } from 'app/components/Icons';
import { EPermission } from 'modules/auth/context/permify/permify.interfaces';
import { usePermify } from 'modules/auth/context';
import { useNavigate, useParams } from 'react-router-dom';
import {
  ApplicationContent,
  PendingApplicationsStatus,
} from './components/ApplicationContent';
import { ButtonPrimary, TextM } from 'app/components';
import { useApplicationsService } from 'modules/products/services/hooks';
import FileIcon from 'app/components/Icons/FileIcon';
import PanelTitle from 'app/components/typography/heading/PanelTitle/PanelTitle';
import { TabsArea } from 'app/components/Tabs/styles';
import { usePersonContext } from 'modules/customer/context';

const renderContent = (tabName: string) => {
  switch (tabName) {
    case 'applications':
      return <ApplicationContent />;
    case 'pending':
      return <ApplicationContent pending={true} />;
    default:
      return <ApplicationContent />;
  }
};

const OperationsMain = () => {
  const theme = useTheme();
  const params = useParams();
  const navigate = useNavigate();
  const { isAuthorized } = usePermify();
  const [currentTabValue, setCurrentTabValue] = useState(0);
  const [totalPending, updateTotalPending] = useState(0);
  const { setItems, resetBreadcrumbs } = useBreadcrumbsContext();
  const { getApplications } = useApplicationsService();
  const { clearContext } = usePersonContext();

  useEffect(() => {
    clearContext();
    setItems(
      [{ to: '/operations', label: 'Operações' }],
      <FileIcon color={theme.palette.text.secondary} />,
    );
    getApplications(0, 1, undefined, PendingApplicationsStatus).then((res) => {
      if (res) {
        updateTotalPending(res.total_elements ?? 0);
      }
    });
    return resetBreadcrumbs;
  }, []);

  useEffect(() => {
    if (params.tabRoute !== 'pending') return;

    getApplications(0, 1, undefined, PendingApplicationsStatus).then((res) => {
      if (res) {
        updateTotalPending(res.total_elements ?? 0);
      }
    });
  }, [params.tabRoute]);

  const tabItems = [
    {
      title: 'Todas as operações',
      route: '/applications',
      isEnabled: true,
      icon: <FileIcon color={theme.palette.brand.primary.base as string} />,
      permission: EPermission.PRODUCTS_APPLICATIONS,
    },
    {
      title: (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          Operações pendentes{' '}
          {totalPending > 0 && <PendingCount>{totalPending}</PendingCount>}
        </div>
      ),
      route: '/pending',
      isEnabled: true,
      icon: <WarningIcon color={theme.palette.brand.primary.base as string} />,
      permission: EPermission.PRODUCTS_APPLICATIONS,
    },
  ];

  return (
    <OperationsMainContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <PanelTitle>Operações</PanelTitle>
        <HeaderButtons>
          <ButtonPrimary
            btnIcon={<AddIcon color="white" />}
            iconPosition="right"
            onClick={() => {
              navigate('/products/application');
            }}
          >
            <TextM
              weight="Semibold"
              style={{
                marginRight: '11px',
                color: 'white',
              }}
            >
              Criar nova solicitação
            </TextM>
          </ButtonPrimary>
        </HeaderButtons>
      </div>
      <TabsArea>
        <CustomTabs
          value={currentTabValue}
          route={routingPath.operations.main}
          variant="scrollable"
          items={tabItems
            .filter((tab) => isAuthorized(tab.permission) && tab.isEnabled)
            .map((tab) => ({
              title: tab.title,
              icon: tab.icon,
              route: tab.route,
            }))}
          handleChange={(value) => setCurrentTabValue(value)}
          showBorder={false}
        />
      </TabsArea>
      {renderContent(params.tabRoute || 'applications')}
    </OperationsMainContainer>
  );
};

export default OperationsMain;
